import Modals from '@js/uses/modals';
import loadVue from '@js/helpers/loadVue';
import Cart from '@js/components/cart';

loadVue(document.querySelectorAll('[data-vue-cart]'), {
    name: 'vue-cart',
    components: {
        Cart
    },
    uses: [
        Modals,
    ],
})